import type { InstallationLevel } from "../installationHeights";
import type { ElementCategory } from "../deviceCategories";
import type { InstallationLevelOf } from "./types";

// Floor first: a "Bodensteckdose" is a socket, but it sits in the floor.
const NAME_RULES: Array<[RegExp, InstallationLevel]> = [
  [/boden(dose|tank|kanal|steckdose|einbau)|unterflur|bodendose/i, "floor"],
  [/leuchte|lichtband|downlight|strahler|lampe|notleucht|luminaire|rauchmelder|brandmelder|präsenz|bewegungsmelder/i, "luminaire"],
  [/schalter|taster|dimmer|steckdose|dose|cee|energiew|switch|socket/i, "controls"],
];

// "lighting" also holds switches, so the category is only the fallback.
const CEILING_CATEGORIES: ElementCategory[] = ["lighting", "emergencyLighting", "fireAlarm"];

export const installationLevelOf: InstallationLevelOf = ({ deviceType, name }) => {
  const label = deviceType?.name ?? name ?? "";
  const byName = NAME_RULES.find(([pattern]) => pattern.test(label));
  if (byName) return byName[1];
  return deviceType && CEILING_CATEGORIES.includes(deviceType.category) ? "luminaire" : "controls";
};
